module.exports = __webpack_public_path__ + "media/bootstrap-icons/record-circle-96c976de.svg";